// Утилиты для Form4

// Функция для вычисления значения I (здор)
export const calculateIZdor = (item) => {
  const otherColumns = [
    'osldolap', 'sosldolap', 'usdolap', 'svsuhdolap', 
    'svvtrdolap', 'svburdolap', 'stsuhdolap', 'stvtrdolap', 'stburdolap'
  ];
  
  const sum = otherColumns.reduce((total, column) => {
    const value = item[column];
    if (value === '' || value === undefined || value === null) {
      return total + 0;
    }
    const numValue = parseInt(value);
    return total + (isNaN(numValue) ? 0 : numValue);
  }, 0);
  
  return Math.max(0, 100 - sum);
};

// Функция для проверки валидности суммы столбцов
export const isSumValid = (item) => {
  const otherColumns = [
    'osldolap', 'sosldolap', 'usdolap', 'svsuhdolap', 
    'svvtrdolap', 'svburdolap', 'stsuhdolap', 'stvtrdolap', 'stburdolap'
  ];
  
  const sum = otherColumns.reduce((total, column) => {
    const value = item[column];
    if (value === '' || value === undefined || value === null) {
      return total + 0;
    }
    const numValue = parseInt(value);
    return total + (isNaN(numValue) ? 0 : numValue);
  }, 0);
  
  return sum <= 100;
};

// Функция для расчета СКС
export const calculateSKS = (item) => {
  // Преобразуем все значения в числа
  const i = calculateIZdor(item);
  const ii = Number(item.osldolap) || 0;
  const iii = Number(item.sosldolap) || 0;
  const iv = Number(item.usdolap) || 0;
  const va = Number(item.svsuhdolap) || 0;
  const vb = Number(item.svvtrdolap) || 0;
  const vc = Number(item.svburdolap) || 0;
  const vg = Number(item.stsuhdolap) || 0;
  const vd = Number(item.stvtrdolap) || 0;
  const ve = Number(item.stburdolap) || 0;
  
  // Формула СКС: (I*1+II*2+III*3+IV*4+(V(A)+V(Б)+V(В)+V(Г)+V(Д)+V(E))*5)/100
  const vSum = va + vb + vc + vg + vd + ve;
  const numerator = (i * 1) + (ii * 2) + (iii * 3) + (iv * 4) + (vSum * 5);
  const denominator = 100;
  
  if (denominator === 0) {
    return 0;
  }
  
  const result = numerator / denominator;
  const rounded = Math.round(result * 100) / 100;
  
  return rounded;
};

// Функция для расчета отпада общего
export const calculateOtpadObsh = (item) => {
  const iv = Number(item.usdolap) || 0;
  const va = Number(item.svsuhdolap) || 0;
  const vb = Number(item.svvtrdolap) || 0;
  const vc = Number(item.svburdolap) || 0;
  const vg = Number(item.stsuhdolap) || 0;
  const vd = Number(item.stvtrdolap) || 0;
  const ve = Number(item.stburdolap) || 0;
  
  // Отпад общий = IV + VA + VB + VC + VГ + VD + VE
  const result = iv + va + vb + vc + vg + vd + ve;
  
  return result;
};

// Функция для расчета отпада текущего
export const calculateOtpadTek = (item) => {
  const iv = Number(item.usdolap) || 0;
  const va = Number(item.svsuhdolap) || 0;
  const vb = Number(item.svvtrdolap) || 0;
  const vc = Number(item.svburdolap) || 0;
  
  // Отпад текущий = IV + VA + VB + VC
  const result = iv + va + vb + vc;
  
  return result;
};

